import { useEffect } from "react";

const RefrigeratorRepair = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#222222] text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Image container with mobile optimization */}
        <div className="h-[40vh] md:h-screen relative">
          <img
            src="/lovable-uploads/2019b980-f8e1-46ec-8c0b-26c20616bda0.png"
            alt="Refrigerator repair service"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 overflow-y-auto">
          <h1 className="text-4xl font-bold mb-8 text-accent">Refrigerator Repair Services</h1>
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-accent-light mb-4">Expert Refrigerator Repair in GTA</h2>
              <p className="text-gray-300 mb-4">
                Our expert technicians specialize in repairing all types of refrigerators. We understand the urgency
                of refrigerator repairs and provide quick, reliable service to prevent food spoilage.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Our Services Include:</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Cooling system repairs</li>
                <li>Compressor replacement</li>
                <li>Thermostat calibration</li>
                <li>Ice maker repairs</li>
                <li>Seal replacement</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Why Choose Us?</h3>
              <ul className="space-y-4 text-gray-300">
                <li>✓ 24/7 emergency service</li>
                <li>✓ Factory-trained technicians</li>
                <li>✓ Original replacement parts</li>
                <li>✓ Upfront pricing</li>
                <li>✓ Satisfaction guarantee</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Common Refrigerator Issues</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                <div>• Not cooling properly</div>
                <div>• Ice maker problems</div>
                <div>• Water leaks</div>
                <div>• Strange noises</div>
                <div>• Door seal issues</div>
                <div>• Temperature fluctuations</div>
              </div>
            </section>

            <div className="mt-8">
              <a
                href="tel:416-805-5075"
                className="bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-lg inline-block transition-colors"
              >
                Call Now for Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefrigeratorRepair;
